var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c(_vm.bpiVersion,{tag:"component",staticClass:"bg-gray-200 font-output",attrs:{"bpi":_vm.bpi,"bpiOutPut":_vm.bpiOutPut}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }